import type { WebhookPayload } from './types';
import { getDeviceType } from './utils';
import { inputValue } from './dom';

async function postJson(url: string, payload: WebhookPayload): Promise<void> {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const errorData = await res.json().catch(() => ({} as { message?: string }));
    const errorMessage = errorData.message || 'Unknown server error.';
    throw new Error(`HTTP Error ${res.status}: ${errorMessage}`);
  }
}

export function sendToMakeWebhook(payload: WebhookPayload): Promise<void> {
  return postJson('/wp-json/moj-formularz/v1/wyslij-multi', payload);
}

/**
 * Wysyła payload do serwera SRF (kalkulator ceny) przez proxy w WordPressie.
 * Proxy dokłada nagłówek x-srf-intake-token po stronie serwera (token nie jest w bundlu).
 */
export function sendToSrf(payload: WebhookPayload): Promise<void> {
  return postJson('/wp-json/moj-formularz/v1/srf', payload);
}

export function getFormSnapshot(): Record<string, unknown> {
  try {
    return {
      email: inputValue('email').trim(),
      pickup: inputValue('pickup').trim(),
      destination: inputValue('destination').trim(),
      pickupDate: inputValue('pickupDate'),
      pickupTime: inputValue('pickupTime'),
      returnDate: inputValue('returnDate'),
      returnTime: inputValue('returnTime'),
      passengers: inputValue('passengers'),
      bags: inputValue('bags'),
      notes: inputValue('notes').trim(),
      tripType: inputValue('tripType'),
      deviceType: getDeviceType(),
    };
  } catch (err) {
    return { error: 'Snapshot failed: ' + (err instanceof Error ? err.message : String(err)) };
  }
}

export async function logFormEvent(
  event: string,
  message: string,
  extra: Record<string, unknown> = {},
): Promise<void> {
  try {
    await fetch('/wp-json/form-logs/v1/write', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        secret: 'volubusTOKEN2018',
        event,
        message,
        extra,
        url: window.location.href,
        timestamp: new Date().toISOString(),
      }),
    });
  } catch {
    // Logging must never break the form.
  }
}
